"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionDestroyedEvent = void 0;
const event_types_1 = require("../enums/event-types");
class SessionDestroyedEvent {
    constructor() {
        this.eventType = SessionDestroyedEvent.EventType;
        this.timestamp = new Date();
    }
}
exports.SessionDestroyedEvent = SessionDestroyedEvent;
SessionDestroyedEvent.EventType = event_types_1.SessionServiceEventType.SESSION_DESTROYED;
